import { startAnalytics } from './lib/analytics';
fetch('/api/analytics-config').then(r => r.ok ? r.json() : null).then(info => {
  if (info) void startAnalytics(info, false);
}).catch(() => {});
const button = document.querySelector<HTMLButtonElement>('#copy-prompt');
button?.addEventListener('click', async () => {
  const prompt = document.querySelector('#workflow-prompt')?.textContent ?? '';
  const status = document.querySelector('#copy-status');
  try {
    await navigator.clipboard.writeText(prompt);
    if (status) status.textContent = 'Prompt copied';
  } catch {
    if (status) status.textContent = 'Select the prompt above and copy it.';
  }
});
